import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";

import { SelectField } from "components/AddVaccineForm/components";

import style from "../AddVaccineForm.module.css";
import { REACTION_OPTIONS, REACTION_YES } from "../constants";
import { DateField } from "./DateField";

/*
 * `unwrapped` hands the fields back without their own grid, so a caller can place them in
 * one it already owns. With the administration fields hidden this section and Vaccine
 * details have two fields each, and left as separate grids they stacked into two half-empty
 * rows (KIN-1883).
 */
export const ReactionSection = ({ unwrapped = false }) => {
  const { watch, setValue } = useFormContext();
  const isGivenElsewhere = watch("givenElsewhere");
  /*
   * The expiry belongs to the batch, so once a batch is chosen the field is derived and
   * editing it can only make the record disagree with the vial (KIN-1740, and the
   * disagreement KIN-1703 is about). The same treatment the dose already gets from the
   * product. Left editable whenever the number is typed, which is every manual entry and
   * every vial the registry does not hold.
   */
  const isExpiryDerivedFromBatch = !!watch("vaccineBatchId");
  const reaction = watch("reaction");
  const reactionDate = watch("reactionDate");

  // A reaction date only means something when a reaction is recorded (KIN-1737). The
  // form used to offer it whichever way Reaction was set, so a record could say there
  // was no reaction and give the date of one.
  const hasReaction = reaction === REACTION_YES;

  // Disabling the input is not enough on its own: the payload is built from form state,
  // so a date entered before Reaction was changed would still be submitted. Cleared
  // rather than merely hidden.
  useEffect(() => {
    if (!hasReaction && reactionDate) {
      setValue("reactionDate", "", { shouldValidate: true });
    }
  }, [hasReaction, reactionDate, setValue]);

  const fields = (
    <>
      {/* A property of the vial, and we never had the vial (KIN-1883). */}
      {!isGivenElsewhere && (
        <DateField
          name="expiryDate"
          label="Expiry date"
          placeholder={
            isExpiryDerivedFromBatch
              ? "From the selected batch"
              : "Select expiry date"
          }
          required={!isExpiryDerivedFromBatch}
          disabled={isExpiryDerivedFromBatch}
        />
      )}

      <SelectField
        name="reaction"
        label="Reaction"
        options={REACTION_OPTIONS}
        placeholder="Select"
      />

      <DateField
        name="reactionDate"
        label="Reaction Date"
        placeholder={hasReaction ? "Select" : "No reaction recorded"}
        disabled={!hasReaction}
      />
    </>
  );

  if (unwrapped) return fields;

  return <div className={style.inputRowThree}>{fields}</div>;
};
